import React, { Component } from 'react';

class AboutV2 extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + '/';

    return (
      <div id='apropos' className="ltn__about-us-area pt-120 pb-90 ">
        <div className="container">
          <div className="row">
            {/* Infos à gauche */}
            <div className="col-lg-6 align-self-center">
              <div className="about-us-info-wrap">
                <div className="section-title-area ltn__section-title-2--- mb-30">
                  <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">Projet Diamantine</h6>
                  <h1 className="section-title">
                    Un immeuble moderne au cœur de Tanger
                  </h1>
                  <p>
                    Le projet Diamantine offre des appartements lumineux et modernes, avec 2 chambres et salon, dans un immeuble en finission haut standing idéalement situé, alliant élégance, confort et qualité pour la famille ou l’investissement.
                  </p>
                </div>

                <ul className="ltn__list-item-1 ltn__list-item-1-before clearfix">
                  <li className='mt-0'>Service conciergerie integré 24h/24h</li>
                  <li className='mt-0'>Parking souterrain privatif </li>
                  <li className='mt-0'>Ascenseur moderne</li>
                  <li className='mt-0'>Local commercial en rez-de-chaussée</li>
                  <li className='mt-0'>Terrasse avec vue dégagée et espaces verts</li>
                  <li className='mt-0'>Gestion Automatisée (Smart Home)</li>
                </ul>

                <ul className="ltn__list-item-2 ltn__list-item-2-before ltn__flat-info">
                  <li>
                    <span>2 <i className="flaticon-bed" /></span>
                    Chambres
                    <br/><br/>
                  </li>
                  <li>
                    <span>60-70 <i className="flaticon-square-shape-design-interface-tool-symbol" /></span>
                    m² habitables<br/><br/>
                  </li>
                  <li>
                    <span>2 <i className="flaticon-clean" /></span>
                    Salle de bain <br /> équipée
                  </li>
                  <li>
                    <span>1 <i className="flaticon-car" /></span>
                    Place parking<br/> dédiée
                  </li>
                  
                  <li>
                    <span>4 <i className="flaticon-building" /></span>
                    -Étages  <br/>-terrasse
                  </li>
                </ul>
                <ul className="ltn__list-item-2 ltn__list-item-2-before--- ltn__list-item-2-img mb-50">
                  <li>
                      {/* <img src={publicUrl + "assets/img/img-slide/11.jpg"} alt="Intérieur Diamantine" /> */}
                      <img src={publicUrl + "assets/img/others/20.png"} alt="Intérieur Diamantine" />
                  </li>
                  <li>
                      <img src={publicUrl + "assets/img/others/19.png"}  alt="Façade moderne" />
                  </li>
                  <li>
                      <img src={publicUrl + "assets/img/others/21.jpg"} alt="Espaces communs" />
                  </li>
                </ul>

                <div className="btn-wrapper animated go-top">
                  <a href="#contact" className="theme-btn-1 btn btn-effect-1">Prendre rendez-vous</a>
                </div>
              </div>
            </div>
            {/* Image à droite */}
            <div className="col-lg-6 align-self-center">
              <div className="about-us-img-wrap about-img-right">
                <img src={publicUrl + "assets/img/others/17.png"}  alt="Diamantine - Immeuble moderne à Tanger" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutV2;
